module.exports = __webpack_public_path__ + "static/media/wind.d85166c0.mp3";